import { useMemo } from 'react';
import { VendorStatus } from '@sib/api';
import { useTranslation } from '@sib/i18n';
import { getVendorStatusColor } from './vendor-status-styles';

const VENDOR_STATUS_ORDER = Object.values(VendorStatus);

interface VendorStatusOption<T> {
  value: T;
  label: string;
  color: string;
}

export const useVendorStatusOptions = <T extends string>() => {
  const { t } = useTranslation();

  return useMemo(
    () =>
      VENDOR_STATUS_ORDER.map(value => ({
        value,
        label: t(`enums.vendorStatus.${value}`),
        color: getVendorStatusColor(value),
      })),
    [t]
  ) as VendorStatusOption<T>[];
};
